// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recipes_root__26C-Y {\n}\n\n.recipes_row1__3zSaU {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  grid-gap: 8px;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.recipes_row2__2BzCG {\n  display: flex;\n  align-items: center;\n  margin-bottom:10px;\n}\n\n.recipes_select__2hbEs {\n}\n\n.recipes_button__Hyy4_ {\n}\n\n.recipes_recipeNameClickable__3nm9n {\n  cursor: pointer;\n  font-size:24px;\n  font-weight:700;\n  color:#0060C0;\n}\n\n.recipes_nameInput__crSf0 {\n  min-width: 160px;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "recipes_root__26C-Y",
	"row1": "recipes_row1__3zSaU",
	"row2": "recipes_row2__2BzCG",
	"select": "recipes_select__2hbEs",
	"button": "recipes_button__Hyy4_",
	"recipeNameClickable": "recipes_recipeNameClickable__3nm9n",
	"nameInput": "recipes_nameInput__crSf0"
};
module.exports = exports;
